import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";

import MalwareDistribution from "../../../Components/PagesComponents/Dashboard/MalwareDistribution/MalwareDistribution";
import CustomTable from "../../../Components/common/Table/CustomTable";
import Card from "../../../Components/common/Card/Card";
import ChartLineIcon from "../../../Components/Icon-SVG/ChartLineIcon";
import ListPopup from "../../../Components/PagesComponents/Dashboard/ListPopup/ListPopup";
import OutlookIcon from "../../../Components/Icon-SVG/OutlookIcon";

import { dashboardHeader } from "../../../utils/constants/tableHeaders";

import {
  RequestDailyIntegrationSubmissionCount,
  RequestIntegrationSubmissionCount,
  RequestIntegrationSubmissionState,
} from "../../../store/actions/dashboardActions";

import "./styles.scss";

//GET FILE ID IN URL
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const OutlookAddIn = () => {
  const licenceCheck = useSelector((state) => state?.users.licenceCheck);
  const submissionsCount = useSelector((state) => state.dashboard.integrationSubmissionCount);
  const dailySubmissionsCount = useSelector(
    (state) => state.dashboard.dailyIntegrationSubmissionCount,
  );
  const cleanState = useSelector((state) => state.dashboard.integrationCleanState);
  const suspiciousState = useSelector((state) => state.dashboard.integrationSuspiciousState);
  const maliciousState = useSelector((state) => state.dashboard.integrationMaliciousState);

  //SET QUERY FOR GETTING DATA ID
  let query = useQuery();
  const [listPopupActive, setListPopupActive] = useState(false);
  const [selectedTimeFilter, setSelectedTimeFilter] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = () => {
      dispatch(RequestIntegrationSubmissionCount("outlook"));
      dispatch(RequestDailyIntegrationSubmissionCount("outlook"));
      dispatch(
        RequestIntegrationSubmissionState({ timeFilter: "all", integrationType: "outlook" }),
      );
    };

    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 28000);

    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    if (query.get("data") !== null) {
      setListPopupActive(true);
    } else {
      setListPopupActive(false);
    }
  }, [query]);

  return (
    <div>
      {!licenceCheck?.key && (
        <div className="file-card__content--licence">
          <p>Your license is not active, please update your license key.</p>
          <p>
            Click
            <Link to="/system-info" className="file-card__content--licence-font">
              <span> Here </span>
            </Link>
            to update your license key.
          </p>
        </div>
      )}
      <div className="outlook">
        <div className="outlook__header">
          <h1>Outlook Add-In</h1>
          <p>Detection of malware by outlook mail.</p>
        </div>
        <div className="outlook__body">
          <div className="outlook__body__logo border ">
            <div className="outlook__body__logo--icon ">
              <OutlookIcon width={150} height={150} />
            </div>
          </div>
          <div className="outlook__body__item">
            <MalwareDistribution
              cleanSubmissionsState={cleanState}
              suspiciousSubmissionsState={suspiciousState}
              maliciousSubmissionsState={maliciousState}
              isIntegration={true}
            />
          </div>
          <table className="border" style={{ height: "208px" }}>
            <thead>
              <tr>
                <th>Outlook Add-In</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a href=""></a>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="outlook__body__card">
            <Card
              title="Daily Upload"
              value={dailySubmissionsCount}
              icon={<ChartLineIcon width={18} height={17} color={"white"} />}
            />
            <Card
              title="Total Upload"
              value={submissionsCount}
              icon={<ChartLineIcon width={18} height={17} color={"white"} />}
            />
          </div>
        </div>
        <div className="outlook__table border" style={{ width: "100%", minHeight: "40.5rem" }}>
          <CustomTable
            exportFile={true}
            column={dashboardHeader}
            tableName={"outlook"}
            leftAction={false}
            tableFolder={"outlook"}
            isSetUrl
            paginationButtons={true}
            className=""
            minBottom="5px"
            customPageSize={10}
            minHeightRow="72px"
            manualPagination={true}
            filterByTime={true}
            selectedTimeFilter={selectedTimeFilter}
            setSelectedTimeFilter={setSelectedTimeFilter}
          />
        </div>
      </div>

      <ListPopup
        onClickOk={() => setListPopupActive(false)}
        show={listPopupActive}
        groupID={query.get("data")}
        tableType={query.get("table")}
        tableType2="outlook"
      />
    </div>
  );
};
export default OutlookAddIn;
